"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Switch: function() {
        return _index.Switch;
    },
    renderSwitch_unstable: function() {
        return _index.renderSwitch_unstable;
    },
    switchClassName: function() {
        return _index.switchClassName;
    },
    switchClassNames: function() {
        return _index.switchClassNames;
    },
    useSwitchStyles_unstable: function() {
        return _index.useSwitchStyles_unstable;
    },
    useSwitch_unstable: function() {
        return _index.useSwitch_unstable;
    }
});
const _index = require("./components/Switch/index");
